export function userId(user) {
  return Number(user?.id ?? user?.user_id);
}

export function fullName(user) {
  if (!user) return "Unknown student";
  return (
    user.name ||
    [user.first_name, user.last_name].filter(Boolean).join(" ") ||
    user.email ||
    `Student #${userId(user)}`
  );
}

export function userMap(users = []) {
  return new Map(users.map((user) => [userId(user), user]));
}

export function money(amount, currency = "INR") {
  if (amount === null || amount === undefined || Number.isNaN(Number(amount))) return "—";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(Number(amount));
}

export function displayDate(value, includeTime = false) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("en-IN", {
    dateStyle: "medium",
    ...(includeTime ? { timeStyle: "short" } : {}),
  }).format(date);
}

export function decisionPayload(decision, { guruId, reason } = {}) {
  const payload = { decision };
  if (decision === "VERIFIED" && guruId) payload.default_guru_id = Number(guruId);
  if (decision === "REJECTED") payload.reason = String(reason || "").trim();
  return payload;
}
